import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function SocialProofSection() {
  const stats = [{
    value: '93%',
    label: 'Reducción promedio de No-Shows en 30 días'
  }, {
    value: '+250',
    label: 'Clínicas transformadas en EE.UU.'
  }, {
    value: '3X',
    label: 'Multiplicación promedio de pacientes nuevos'
  }, {
    value: 'Top 3',
    label: 'Posicionamiento en Google Maps garantizado'
  }];
  return <section className="py-20 px-5 sm:px-6 md:px-8 bg-carbon border-t border-white/5" data-id="element-264">
      <div className="max-w-6xl mx-auto" data-id="element-265">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-266">
          <h2 className="text-3xl md:text-5xl font-black text-gold mb-4" data-id="element-267">
            Resultados que Hablan por Sí Solos
          </h2>
          <div className="w-20 h-1 bg-white/20 mx-auto rounded-full" data-id="element-268"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-269">
          {stats.map((stat, index) => <motion.div key={index} variants={cardVariants} className="bg-[#0a0a0a] border border-white/5 p-8 rounded-xl text-center flex flex-col items-center justify-center hover:border-gold/20 transition-colors duration-300" data-id="element-270">
              <div className="text-4xl md:text-5xl font-black text-gold mb-3" data-id="element-271">
                {stat.value}
              </div>
              <p className="text-gray-400 text-sm md:text-base font-medium leading-snug" data-id="element-272">
                {stat.label}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}